export default __webpack_public_path__ + "static/media/207.0eed0b28.jpg";